/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useAccount, useConnect, useSignMessage } from "wagmi";

import { useRootContext } from "../context/app-context";
import { toast } from "react-toastify";
import { errorTexts, generalIcons } from "../utils/constants";
import useMetaMaskInstalled from "../hooks/useMetaMaskInstalled";
import useChainId from "../hooks/useChainId";
import { handleDeepLink } from "../utils/helper";

export const WalletConnectContext = createContext(null);

const WalletConnectProvider = ({ children }) => {
  WalletConnectProvider.propTypes = {
    children: PropTypes.any,
  };
  const {
    isSignWallet,
    setIsSignWallet,
    selectedNetwork,
    setSelectedWallet,
    selectedWallet,
    setOpenWalletModal,
    openWalletModal,
    switchChainId,
    setIsDisabled,
    isAuthenticated, setIsAuthenticated,
    disconnectCalled, setDisconnectCalled,
    handleDisconnectWallet
  } = useRootContext();
  const isConnectorConnected = localStorage?.getItem("wagmi.recentConnectorId")
  const [loading, setLoading] = useState(false);
  const { signMessageAsync, isPending: isSignaturePending } =
    useSignMessage();
  const { address, connector } = useAccount();
  const { connectAsync, connectors, error: connectError } = useConnect();
  const [currentConnector, setCurrentConnector] = useState();
  const isMetaMaskInstalled = useMetaMaskInstalled();
  const { chainId } = useChainId({ isSignWallet, address });

  const handleConnectWallet = async (connector) => {
    setDisconnectCalled(false);
    setSelectedWallet(connector?.name);
    setIsDisabled(true)
    try {
      if (!isMetaMaskInstalled && connector.name === "MetaMask") {
        handleDeepLink();
      } else if (connector.name === "MetaMask" && address && !isSignWallet) {
        if (chainId === selectedNetwork) {
          handlingErrorAndSign();
        } else {
          switchChainId(selectedNetwork)
        }
      }
      else {
        setCurrentConnector(connector)
        setLoading(true);
        await connectAsync({ connector });
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handlingErrorAndSign = async () => {

    if (address && !connectError) {
      // const appCheckTokenResponse = await getToken(appCheck, true);
      // const appCheckToken = appCheckTokenResponse.token;
      signMessageAsync({ message: address })
        .then(async (signature) => {
          setIsSignWallet(true);
          localStorage.setItem("wagmai_signature", signature);
          setLoading(false);
          setOpenWalletModal(false);
          setIsAuthenticated(true);
          setIsDisabled(false)
          // await authenticateWalletAddressAsync(
          //   address,
          //   appCheckToken,
          //   signature,
          //   setIsAuthenticated,
          //   setIsDisabled
          // );
        })
        .catch(async (error) => {
          setIsDisabled(false)
          const err = JSON.parse(JSON.stringify(error));
          if (Object.keys(err).length > 0) {
            toast.error(
              <div className="flex items-center gap-4">
                <span className="icon">
                  {generalIcons.error}
                </span>
                <div className="">
                  <p>{errorTexts.sign_error}</p>
                </div>
              </div>
            );
            handleDisconnectWallet();
          }
          setLoading(false);
        });
    } else if (connectError) {
      setSelectedWallet(null);
      setIsDisabled(false)
      setLoading(false);
      toast.error(
        <div className="flex items-center gap-4">
          <span className="icon">{generalIcons.error}</span>
          <div className="">
            <p>{errorTexts.user_rejected}</p>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    if (!isSignWallet || isConnectorConnected) {
      if (chainId !== selectedNetwork && address) {
        switchChainId(selectedNetwork)
      }
    }
  }, [chainId]);

  useEffect(() => {
    if (!address) {
      setIsSignWallet(false);
      setIsAuthenticated(false);
      setSelectedWallet(null)
    }
  }, [address])

  useEffect(() => {
    if (connectError) {
      setIsDisabled(false)
      setSelectedWallet(null)
      setLoading(false);
      toast.error(
        <div className="flex items-center gap-4">
          <span className="icon">{generalIcons.error}</span>
          <div className="">
            <p>{errorTexts.user_rejected}</p>
          </div>
        </div>
      );
    }
  }, [connectError])

  useEffect(() => {
    if (address && isConnectorConnected && !disconnectCalled) {
      if (!isSignWallet && chainId === selectedNetwork) {
        handlingErrorAndSign();
      }
    } else if ((address && !isSignWallet) || chainId !== selectedNetwork) {
      handleDisconnectWallet();
    }
  }, [isSignWallet, address, chainId])

  const contextData = React.useMemo(
    () => ({
      loading,
      isAuthenticated,
      address,
      connector,
      handleConnectWallet,
      handleDisconnectWallet,
      walletList: connectors,
      openWalletModal,
      isSignaturePending,
      currentConnector,
      disconnectCalled,
      selectedWallet
    }),
    [
      loading,
      isAuthenticated,
      address,
      connector,
      handleConnectWallet,
      handleDisconnectWallet,
      openWalletModal,
      isSignaturePending,
      currentConnector,
      disconnectCalled,
      selectedWallet
    ]
  );
  return (
    <WalletConnectContext.Provider value={contextData}>
      {children}
    </WalletConnectContext.Provider>
  );
};

export default WalletConnectProvider;

export const useWalletConnect = () => {
  const {
    loading,
    isAuthenticated,
    address,
    connector,
    walletList,
    handleConnectWallet,
    handleDisconnectWallet,
    openWalletModal,
    isSignaturePending,
    currentConnector,
    disconnectCalled,
    selectedWallet
  } = useContext(WalletConnectContext);

  return {
    loading,
    isAuthenticated,
    address,
    connector,
    walletList,
    handleConnectWallet,
    handleDisconnectWallet,
    openWalletModal,
    isSignaturePending,
    currentConnector,
    disconnectCalled,
    selectedWallet
  };
};
